module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/241.aae21165.png";